import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  MenuItem,
  Tooltip,
  Typography,
  Pagination,
  TextField,
  Button,
  Snackbar,
  Alert as MuiAlert,
  Avatar
} from '@mui/material'
import IconButton from '@mui/material/IconButton'
import AddBoxIcon from '@mui/icons-material/AddBox'
import React, { useEffect, useState, forwardRef } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import TablesDrawer from '../tables/tables/tablesDrawer'
import ServiceFloorsDialog from './tables/serviceFloorsDialog'
import MainCard, {
  ConfirmationDialog,
  SnackBarTransition,
  SnackBarHideDuration,
  ShowNoRecordsFound,
  stringAvatar,
  ErrorScreen
} from '../../utils/ui_utils'
import { Add, Delete } from '@mui/icons-material'
import { businessCheck } from '../../utils/utils'
import UserTypeShimmer from '../../utils/ui_components/shimmers/userTypeShimmer'
import { useFetchOutlet } from '../../modules/outlet/outletHooks'
import {
  useCreateServiceFloor,
  useFetchServiceFloor,
  useFetchServiceFloor2,
  useUpdateServiceFloor
} from '../../modules/serviceFloor/serviceFloorHooks'
import {
  useCreateTable,
  useFetchTable,
  useUpdateTable
} from '../../modules/table/tableHooks'
import _ from 'lodash'

function Tables() {
  const [selectedOutlet, setSelectedOutlet] = useState('')
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(12)
  const [pagecount, setPageCount] = useState(1)
  const [page1, setPage1] = useState(1)
  const [limit1, setLimit1] = useState(12)
  const [pagecount1, setPageCount1] = useState(1)
  const [goToPageInput, setGoToPageInput] = useState('')
  const [goToPageInput1, setGoToPageInput1] = useState('')
  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)
  const [serviceFloorDrawerMode, setServiceFloorDrawerMode] = useState('edit')
  const [serviceFloorsDrawerVisibility, setServiceFloorsDrawerVisibility] =
    useState(false)
  const [selectedServiceFloorData, setSelectedServiceFloorData] = useState({})
  const [tablesDrawerMode, setTablesDrawerMode] = useState('edit')
  const [tablesDrawerVisibility, setTablesDrawerVisibility] = useState(false)
  const [selectedTableData, setSelectedTableData] = useState({})
  const [deleteConfirmationVisibility, setDeleteConfirmationVisibility] =
    useState(false)
  const [deleteOperation, setDeleteOperation] = useState('')
  const [outlets, setOutlets] = useState([])
  const [selectedOutletName, setSelectedOutletName] = useState('')

  const { outletFetch, outletFetchData, outletFetchError, outletFetchLoading } =
    useFetchOutlet()
  const {
    fetchServiceFloor,
    fetchServiceFloorData,
    fetchServiceFloorError,
    fetchServiceFloorLoading,
    fetchAllServiceFloor,
    fetchAllServiceFloorData
  } = useFetchServiceFloor()
  const { createServiceFloor } = useCreateServiceFloor()
  const { updateServiceFloor } = useUpdateServiceFloor()
  const { fetchTable, tableFetchData, tableFetchError, tableFetchLoading } =
    useFetchTable()
  const { createTable } = useCreateTable()
  const { updateTable } = useUpdateTable()

  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }

  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
  })

  const history = useNavigate()

  const handlePageChange = async (event, value) => {
    setPage(value)
    if (
      selectedOutlet != null &&
      selectedOutlet != undefined &&
      selectedOutlet != ''
    ) {
      let payload = {
        outlet_id: selectedOutlet,
        pageNumber: value,
        limit: limit
      }
      await fetchTable(payload)
    }
  }
  const handlePageChange1 = async (event, value) => {
    setPage1(value)
    if (
      selectedOutlet != null &&
      selectedOutlet != undefined &&
      selectedOutlet != ''
    ) {
      let payload = {
        outlet_id: selectedOutlet,
        pageNumber: value,
        limit: limit1
      }
      await fetchServiceFloor(payload)
      let payload2 = {
        outlet_id: selectedOutlet,
        pageNumber: 1,
        limit: 1000
      }
      await fetchAllServiceFloor(payload2)
    }
  }

  const handleGoToPageChange = (event) => {
    const value = event.target.value
    if (/^\d+$/.test(value) || value === '') {
      setGoToPageInput(value)
    }
  }

  const handleGoToPageSubmit = () => {
    const pageNum = parseInt(goToPageInput, 10)
    if (pageNum >= 1 && pageNum <= pagecount) {
      handlePageChange(null, pageNum)
      setGoToPageInput('')
    }
  }

  const handleGoToPageKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleGoToPageSubmit()
    }
  }

  const handleGoToPageChange1 = (event) => {
    const value = event.target.value
    if (/^\d+$/.test(value) || value === '') {
      setGoToPageInput1(value)
    }
  }

  const handleGoToPageSubmit1 = () => {
    const pageNum = parseInt(goToPageInput1, 10)
    if (pageNum >= 1 && pageNum <= pagecount1) {
      handlePageChange1(null, pageNum)
      setGoToPageInput1('')
    }
  }

  const handleGoToPageKeyPress1 = (event) => {
    if (event.key === 'Enter') {
      handleGoToPageSubmit1()
    }
  }

  const pageCount = (data1) => {
    let count = Math.ceil(data1 / limit)
    setPageCount(count)
  }
  const pageCount1 = (data1) => {
    let count = Math.ceil(data1 / limit1)
    setPageCount1(count)
  }

  const handleOutletChange = (event) => {
    setSelectedOutlet(event.target.value)
    outlets.map((outlet) => {
      if (outlet._id == event.target.value) {
        setSelectedOutletName(outlet.name)
        return
      }
    })
    fetchTableOnError(event.target.value)
    setPage(1)
    setPage1(1)
  }

  useEffect(() => {
    businessCheck(history)
    let payload = {
      pageNumber: 1,
      limit: 100
    }
    outletFetch(payload)
  }, [])

  useEffect(() => {
    if (outletFetchData.data?.length > 0) {
      setSelectedOutlet(outletFetchData.data[0]._id)
      setSelectedOutletName(outletFetchData.data[0].name)
      setOutlets(outletFetchData.data)
      let payload = {
        outlet_id: outletFetchData.data[0]._id,
        pageNumber: page,
        limit: limit
      }
      fetchTable(payload)
      let payload1 = {
        outlet_id: outletFetchData.data[0]._id,
        pageNumber: page1,
        limit: limit1
      }
      fetchServiceFloor(payload1)
      let payload2 = {
        outlet_id: outletFetchData.data[0]._id,
        pageNumber: 1,
        limit: 1000
      }
      fetchAllServiceFloor(payload2)
    } else {
      setOutlets([])
      setSelectedOutlet('')
      setSelectedOutletName('')
    }
  }, [outletFetchData])

  useEffect(() => {
    if (fetchServiceFloorData.data?.length > 0) {
      pageCount1(fetchServiceFloorData.total)
    }
  }, [fetchServiceFloorData.data])

  useEffect(() => {
    if (tableFetchData.data?.length > 0) {
      pageCount(tableFetchData.total)
    }
  }, [tableFetchData.data])

  const fetchOutletOnError = () => {
    let payload = {
      pageNumber: 1,
      limit: 100
    }
    outletFetch(payload)
  }

  const fetchTableOnError = (outletId) => {
    let payload = {
      outlet_id: outletId,
      pageNumber: 1,
      limit: limit
    }
    fetchTable(payload)
    let payload1 = {
      outlet_id: outletId,
      pageNumber: 1,
      limit: limit1
    }
    fetchServiceFloor(payload1)
    let payload2 = {
      outlet_id: outletId,
      pageNumber: 1,
      limit: 1000
    }
    fetchAllServiceFloor(payload2)
  }

  const ServiceFloorListUI = ({ serviceFloor }) => (
    <MainCard>
      <Grid
        container
        column={6}
        spacing={1}
        sx={{
          p: 2,
          alignItems: 'center',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
          }
        }}
      >
        <Grid item xs md>
          <Grid
            container
            column={6}
            sx={{ alignItems: 'center', cursor: 'pointer' }}
            onClick={() => {
              setServiceFloorsDrawerVisibility(true)
              setServiceFloorDrawerMode('edit')
              setSelectedServiceFloorData(serviceFloor)
            }}
          >
            <Grid item>
              <Avatar {...stringAvatar(serviceFloor?.name)} />
            </Grid>
            <Grid item xs md sx={{ pl: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                {serviceFloor.name}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item textAlign="right">
          <IconButton
            size="small"
            color="lightRed"
            component="span"
            onClick={() => {
              let values = serviceFloor
              setDeleteOperation('servicefloor')
              setSelectedServiceFloorData(values)
              setDeleteConfirmationVisibility(true)
            }}
          >
            <Delete fontSize="small" />
          </IconButton>
        </Grid>
      </Grid>
    </MainCard>
  )

  const TablesListUI = ({ table, index }) => (
    <MainCard id={index}>
      <Grid
        container
        column={6}
        spacing={1}
        sx={{
          p: 2,
          alignItems: 'center',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
          }
        }}
      >
        <Grid item>
          <Avatar {...stringAvatar(table?.name)} />
        </Grid>
        <Grid item xs md>
          <Grid
            container
            direction={'column'}
            sx={{ pl: 1, cursor: 'pointer' }}
            onClick={() => {
              let values = _.cloneDeep(table)
              values.floor_id = table.floor?._id
              setTablesDrawerVisibility(true)
              setTablesDrawerMode('edit')
              setSelectedTableData(values)
            }}
          >
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              {table?.name}
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              {table?.floor?.name}
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              Rate slab #: {table?.price_id}
            </Typography>
          </Grid>
        </Grid>
        <Grid item textAlign="right">
          <IconButton
            size="small"
            color="lightRed"
            component="span"
            onClick={() => {
              let values = _.cloneDeep(table)
              values.floor_id = table.floor?._id
              setDeleteOperation('table')
              setSelectedTableData(values)
              setDeleteConfirmationVisibility(true)
            }}
          >
            <Delete fontSize="small" />
          </IconButton>
        </Grid>
      </Grid>
    </MainCard>
  )

  return (
    <>
      <Helmet title="Tables" />
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Grid item>
          <Typography variant="h4" gutterBottom display="inline">
            Tables and Service Floors
          </Typography>
        </Grid>
        {!outletFetchError &&
          fetchServiceFloorData.data &&
          fetchServiceFloorData.data?.length <= 0 && (
            <Grid item>
              <Button
                startIcon={<Add />}
                variant="contained"
                size="small"
                color="primary"
                onClick={() => {
                  if (
                    selectedOutlet != null &&
                    selectedOutlet != undefined &&
                    selectedOutlet != ''
                  ) {
                    setServiceFloorsDrawerVisibility(true)
                    setSelectedServiceFloorData({
                      name: '',
                      outlet_id: ''
                    })
                    setServiceFloorDrawerMode('new')
                  } else {
                    toastMessage('Select Outlet', 'warning')
                  }
                }}
              >
                Add Service Floor
              </Button>
            </Grid>
          )}
      </Grid>
      <Divider style={{ paddingTop: 10 }} />
      {outletFetchError ? (
        <ErrorScreen
          onClick={() => {
            fetchOutletOnError()
          }}
        />
      ) : (
        <div>
          {
            <Grid container spacing={6} style={{ paddingTop: 10 }}>
              <Grid item md={3}>
                <TextField
                  size="small"
                  label="Outlet"
                  id="outlet_id"
                  name="outlet_id"
                  variant="outlined"
                  margin="dense"
                  value={selectedOutlet}
                  onChange={handleOutletChange}
                  select
                  fullWidth
                >
                  {outlets.map((outlet) => (
                    <MenuItem key={outlet._id} value={outlet._id}>
                      {outlet.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          }
          {fetchServiceFloorError || tableFetchError ? (
            <ErrorScreen
              onClick={() => {
                fetchTableOnError(selectedOutlet)
              }}
            />
          ) : (
            <div>
              {(outletFetchLoading ||
                fetchServiceFloorLoading ||
                tableFetchLoading) && (
                <div>
                  <UserTypeShimmer />
                  <UserTypeShimmer />
                </div>
              )}
              {(!outletFetchLoading ||
                !fetchServiceFloorLoading ||
                !tableFetchLoading) &&
                fetchServiceFloorData.data?.length <= 0 && (
                  <ShowNoRecordsFound />
                )}
              {!tableFetchError &&
                !fetchServiceFloorError &&
                !tableFetchError &&
                !outletFetchLoading &&
                !tableFetchLoading &&
                !fetchServiceFloorLoading &&
                fetchServiceFloorData.data &&
                fetchServiceFloorData.data?.length > 0 && (
                  <Grid container spacing={5} sx={{ paddingTop: 5 }}>
                    <Grid container direction="column" mx={10} my={10}>
                      <Grid container direction="column">
                        <Grid
                          container
                          spacing={6}
                          sx={{ alignItems: 'center' }}
                        >
                          <Grid item>
                            <Typography
                              variant="h5"
                              gutterBottom
                              display="inline"
                            >
                              Service Floors
                            </Typography>
                          </Grid>
                          <Grid item>
                            <Tooltip
                              title="Add Service Floor"
                              placement="bottom"
                            >
                              <IconButton
                                variant="contained"
                                size="small"
                                color="primary"
                                onClick={() => {
                                  setServiceFloorsDrawerVisibility(true)
                                  setServiceFloorDrawerMode('new')
                                  setSelectedServiceFloorData({
                                    name: ''
                                  })
                                }}
                              >
                                <AddBoxIcon />
                              </IconButton>
                            </Tooltip>
                          </Grid>
                        </Grid>
                        <Grid container>
                          <Grid item xs sm md>
                            <Box sx={{ margin: 2 }}>
                              <Card raised sx={{ borderRadius: 3 }}>
                                <CardContent>
                                  <Grid
                                    container
                                    columns={6}
                                    rowSpacing={3}
                                    columnSpacing={3}
                                  >
                                    {fetchServiceFloorData?.data.map(
                                      (serviceFloor, index) => (
                                        <Grid
                                          item
                                          xs={6}
                                          sm={3}
                                          md={2}
                                          key={index}
                                        >
                                          <ServiceFloorListUI
                                            serviceFloor={serviceFloor}
                                          />
                                        </Grid>
                                      )
                                    )}
                                  </Grid>
                                </CardContent>
                                {pagecount1 > 1 && (
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      gap: 2,
                                      p: 2,
                                      backgroundColor: 'grey.50',
                                      borderRadius: 1
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        width: '100%'
                                      }}
                                    >
                                      <Pagination
                                        count={pagecount1}
                                        page={page1}
                                        color="secondary"
                                        size="small"
                                        boundaryCount={2}
                                        siblingCount={0}
                                        showFirstButton
                                        showLastButton
                                        onChange={handlePageChange1}
                                        sx={{
                                          '& .MuiPaginationItem-root': {
                                            transition: 'all 0.2s ease-in-out'
                                          }
                                        }}
                                      />
                                    </Box>
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: 1.5,
                                        backgroundColor: 'white',
                                        p: 2,
                                        borderRadius: 1,
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                                        transition:
                                          'box-shadow 0.2s ease-in-out',
                                        '&:hover': {
                                          boxShadow:
                                            '0 2px 6px rgba(0,0,0,0.12)'
                                        }
                                      }}
                                    >
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: 'text.secondary',
                                          fontWeight: 500
                                        }}
                                      >
                                        Jump to
                                      </Typography>
                                      <TextField
                                        size="small"
                                        value={goToPageInput1}
                                        onChange={handleGoToPageChange1}
                                        onKeyPress={handleGoToPageKeyPress1}
                                        placeholder="Page"
                                        sx={{
                                          width: '80px',
                                          '& .MuiOutlinedInput-root': {
                                            backgroundColor: 'white',
                                            transition: 'all 0.2s ease-in-out',
                                            '& fieldset': {
                                              borderColor: 'grey.300',
                                              borderWidth: '1px'
                                            },
                                            '&:hover fieldset': {
                                              borderColor: 'secondary.main',
                                              borderWidth: '1.5px'
                                            },
                                            '&.Mui-focused fieldset': {
                                              borderColor: 'secondary.main',
                                              borderWidth: '2px',
                                              boxShadow:
                                                '0 0 0 3px rgba(156, 39, 176, 0.1)'
                                            }
                                          },
                                          '& .MuiOutlinedInput-input': {
                                            textAlign: 'center',
                                            fontWeight: 500,
                                            padding: '7px 8px',
                                            height: '20px',
                                            lineHeight: '20px'
                                          }
                                        }}
                                      />
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: 'text.secondary',
                                          fontWeight: 400
                                        }}
                                      >
                                        of {pagecount1}
                                      </Typography>
                                      <Button
                                        variant="contained"
                                        color="secondary"
                                        size="small"
                                        onClick={handleGoToPageSubmit1}
                                        disabled={
                                          !goToPageInput1 ||
                                          parseInt(goToPageInput1, 10) < 1 ||
                                          parseInt(goToPageInput1, 10) >
                                            pagecount1
                                        }
                                        sx={{
                                          textTransform: 'none',
                                          fontWeight: 500,
                                          px: 2,
                                          py: 0.75,
                                          height: '34px',
                                          lineHeight: 1,
                                          transition: 'all 0.2s ease-in-out',
                                          '&:hover': {
                                            transform: 'translateY(-1px)',
                                            boxShadow:
                                              '0 4px 8px rgba(156, 39, 176, 0.3)'
                                          },
                                          '&:active': {
                                            transform: 'translateY(0)'
                                          }
                                        }}
                                      >
                                        Go
                                      </Button>
                                    </Box>
                                  </Box>
                                )}
                              </Card>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid container direction="column" my={10}>
                        <Grid
                          container
                          spacing={6}
                          sx={{ alignItems: 'center' }}
                        >
                          <Grid item>
                            <Typography
                              variant="h5"
                              gutterBottom
                              display="inline"
                            >
                              Tables
                            </Typography>
                          </Grid>
                          <Grid item>
                            <Tooltip title="Add Table" placement="bottom">
                              <IconButton
                                variant="contained"
                                size="small"
                                color="primary"
                                onClick={() => {
                                  setTablesDrawerVisibility(true)
                                  setTablesDrawerMode('new')
                                  setSelectedTableData({
                                    name: '',
                                    price_id: '',
                                    floor_id: ''
                                  })
                                }}
                              >
                                <AddBoxIcon />
                              </IconButton>
                            </Tooltip>
                          </Grid>
                        </Grid>
                        <Grid container>
                          <Grid item xs sm md>
                            <Box sx={{ margin: 2 }}>
                              <Card raised sx={{ borderRadius: 3 }}>
                                <CardContent>
                                  <Grid
                                    container
                                    columns={6}
                                    rowSpacing={3}
                                    columnSpacing={3}
                                  >
                                    {tableFetchData.data?.map((row, i) => (
                                      <Grid item xs={6} sm={3} md={2} key={i}>
                                        <TablesListUI table={row} index={i} />
                                      </Grid>
                                    ))}
                                  </Grid>
                                </CardContent>
                                {pagecount > 1 && (
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      gap: 2,
                                      p: 2,
                                      backgroundColor: 'grey.50',
                                      borderRadius: 1
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        width: '100%'
                                      }}
                                    >
                                      <Pagination
                                        count={pagecount}
                                        page={page}
                                        color="secondary"
                                        size="small"
                                        boundaryCount={2}
                                        siblingCount={0}
                                        showFirstButton
                                        showLastButton
                                        onChange={handlePageChange}
                                        sx={{
                                          '& .MuiPaginationItem-root': {
                                            transition: 'all 0.2s ease-in-out'
                                          }
                                        }}
                                      />
                                    </Box>
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: 1.5,
                                        backgroundColor: 'white',
                                        p: 2,
                                        borderRadius: 1,
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                                        transition:
                                          'box-shadow 0.2s ease-in-out',
                                        '&:hover': {
                                          boxShadow:
                                            '0 2px 6px rgba(0,0,0,0.12)'
                                        }
                                      }}
                                    >
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: 'text.secondary',
                                          fontWeight: 500
                                        }}
                                      >
                                        Jump to
                                      </Typography>
                                      <TextField
                                        size="small"
                                        value={goToPageInput}
                                        onChange={handleGoToPageChange}
                                        onKeyPress={handleGoToPageKeyPress}
                                        placeholder="Page"
                                        sx={{
                                          width: '80px',
                                          '& .MuiOutlinedInput-root': {
                                            backgroundColor: 'white',
                                            transition: 'all 0.2s ease-in-out',
                                            '& fieldset': {
                                              borderColor: 'grey.300',
                                              borderWidth: '1px'
                                            },
                                            '&:hover fieldset': {
                                              borderColor: 'secondary.main',
                                              borderWidth: '1.5px'
                                            },
                                            '&.Mui-focused fieldset': {
                                              borderColor: 'secondary.main',
                                              borderWidth: '2px',
                                              boxShadow:
                                                '0 0 0 3px rgba(156, 39, 176, 0.1)'
                                            }
                                          },
                                          '& .MuiOutlinedInput-input': {
                                            textAlign: 'center',
                                            fontWeight: 500,
                                            padding: '7px 8px',
                                            height: '20px',
                                            lineHeight: '20px'
                                          }
                                        }}
                                      />
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: 'text.secondary',
                                          fontWeight: 400
                                        }}
                                      >
                                        of {pagecount}
                                      </Typography>
                                      <Button
                                        variant="contained"
                                        color="secondary"
                                        size="small"
                                        onClick={handleGoToPageSubmit}
                                        disabled={
                                          !goToPageInput ||
                                          parseInt(goToPageInput, 10) < 1 ||
                                          parseInt(goToPageInput, 10) >
                                            pagecount
                                        }
                                        sx={{
                                          textTransform: 'none',
                                          fontWeight: 500,
                                          px: 2,
                                          py: 0.75,
                                          height: '34px',
                                          lineHeight: 1,
                                          transition: 'all 0.2s ease-in-out',
                                          '&:hover': {
                                            transform: 'translateY(-1px)',
                                            boxShadow:
                                              '0 4px 8px rgba(156, 39, 176, 0.3)'
                                          },
                                          '&:active': {
                                            transform: 'translateY(0)'
                                          }
                                        }}
                                      >
                                        Go
                                      </Button>
                                    </Box>
                                  </Box>
                                )}
                              </Card>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
            </div>
          )}
        </div>
      )}

      <TablesDrawer
        createMode={tablesDrawerMode === 'new'}
        outlet={selectedOutletName}
        title={tablesDrawerMode == 'new' ? 'Create New Table' : 'Edit Table'}
        okText={tablesDrawerMode == 'new' ? 'Create' : 'Update'}
        initialValues={selectedTableData}
        visible={tablesDrawerVisibility}
        floorsData={fetchAllServiceFloorData.data}
        onClose={() => {
          setTablesDrawerVisibility(false)
        }}
        onSubmit={async (values) => {
          let value = _.cloneDeep(values)
          value.price_id = +value.price_id
          value.name = value.name.trim()
          if (tablesDrawerMode == 'new') {
            value.outlet_id = selectedOutlet
            let tables = []
            if (values.from != null && values.to != null) {
              for (let i = values.from; i <= values.to; i++) {
                tables.push({
                  name: `${values.name} ${i}`,
                  floor_id: values.floor_id,
                  price_id: values.price_id,
                  outlet_id: value.outlet_id
                })
              }
            } else {
              tables.push(value)
            }
            let result = {
              tables: tables,
              outlet_id: value.outlet_id
            }
            await createTable(result, async (success, error, message) => {
              if (error) {
                setTablesDrawerVisibility(true)
                toastMessage(message, 'error')
              } else {
                setTablesDrawerVisibility(false)
                toastMessage(message, 'success')
                if (
                  selectedOutlet != null &&
                  selectedOutlet != undefined &&
                  selectedOutlet != ''
                ) {
                  let params = {
                    outlet_id: selectedOutlet,
                    pageNumber: page,
                    limit: limit
                  }
                  await fetchTable(params)
                }
              }
            })
          } else {
            value.id = value._id
            delete value?._id
            delete value?.business_id
            delete value.floor
            delete value.key
            updateTable(value, async (success, error, message) => {
              if (error) {
                setTablesDrawerVisibility(true)
                toastMessage(message, 'error')
              } else {
                setTablesDrawerVisibility(false)
                toastMessage(message, 'success')
                if (
                  selectedOutlet != null &&
                  selectedOutlet != undefined &&
                  selectedOutlet != ''
                ) {
                  let params = {
                    outlet_id: selectedOutlet,
                    pageNumber: page,
                    limit: limit
                  }
                  await fetchTable(params)
                }
              }
            })
          }
        }}
      />

      <ServiceFloorsDialog
        outlet={selectedOutletName}
        visible={serviceFloorsDrawerVisibility}
        title={
          serviceFloorDrawerMode == 'new'
            ? 'Create Service Floor'
            : 'Edit Service Floor'
        }
        okText={serviceFloorDrawerMode == 'new' ? 'Create' : 'Update'}
        initialValues={selectedServiceFloorData}
        onClose={() => {
          setServiceFloorsDrawerVisibility(false)
        }}
        onSubmit={async (value) => {
          let values = _.cloneDeep(value)
          values.name = values.name.trim()
          if (serviceFloorDrawerMode == 'new') {
            values.outlet_id = selectedOutlet
            await createServiceFloor(
              values,
              async (success, error, message) => {
                if (error) {
                  setServiceFloorsDrawerVisibility(true)
                  toastMessage(message, 'error')
                } else {
                  setServiceFloorsDrawerVisibility(false)
                  toastMessage(message, 'success')
                  if (
                    selectedOutlet != null &&
                    selectedOutlet != undefined &&
                    selectedOutlet != ''
                  ) {
                    let params = {
                      outlet_id: selectedOutlet,
                      pageNumber: page1,
                      limit: limit1
                    }
                    fetchServiceFloor(params)
                    let params2 = {
                      outlet_id: selectedOutlet,
                      pageNumber: 1,
                      limit: 1000
                    }
                    fetchAllServiceFloor(params2)
                    let params3 = {
                      outlet_id: selectedOutlet,
                      pageNumber: page,
                      limit: limit
                    }
                    fetchTable(params3)
                  }
                }
              }
            )
          } else {
            values.id = values._id
            delete values._id
            delete values.business_id
            delete values.key
            updateServiceFloor(values, async (success, error, message) => {
              if (error) {
                setServiceFloorsDrawerVisibility(true)
                toastMessage(message, 'error')
              } else {
                setServiceFloorsDrawerVisibility(false)
                toastMessage(message, 'success')
                if (
                  selectedOutlet != null &&
                  selectedOutlet != undefined &&
                  selectedOutlet != ''
                ) {
                  let params = {
                    outlet_id: selectedOutlet,
                    pageNumber: page1,
                    limit: limit1
                  }
                  fetchServiceFloor(params)
                  let params2 = {
                    outlet_id: selectedOutlet,
                    pageNumber: 1,
                    limit: 1000
                  }
                  fetchAllServiceFloor(params2)
                  let params3 = {
                    outlet_id: selectedOutlet,
                    pageNumber: page,
                    limit: limit
                  }
                  fetchTable(params3)
                }
              }
            })
          }
        }}
      />
      <ConfirmationDialog
        visibility={deleteConfirmationVisibility}
        title={
          deleteOperation == 'table' ? 'Delete Table' : 'Delete Service Floor'
        }
        message={
          deleteOperation == 'table'
            ? `Do you want to delete Table - ${selectedTableData.name} ?`
            : `Do you want to delete Service Floor - ${selectedServiceFloorData.name} ?`
        }
        okText="Delete"
        cancelText={'Cancel'}
        onCancel={() => {
          setDeleteConfirmationVisibility(false)
        }}
        onOk={async () => {
          if (deleteOperation == 'table') {
            let value = _.cloneDeep(selectedTableData)
            value.id = value._id
            value.price_id = +value.price_id
            delete value?._id
            delete value?.business_id
            delete value.floor
            value.delete_status = true
            delete value.key
            updateTable(value, async (success, error, message) => {
              if (error) {
                setDeleteConfirmationVisibility(true)
                toastMessage('Table deletion failed', 'error')
              } else {
                if (tableFetchData.length - 1 >= 1) {
                  let params = {
                    outlet_id: selectedOutlet,
                    pageNumber: page,
                    limit: limit
                  }
                  await fetchTable(params)
                } else {
                  setPage(1)
                  let params = {
                    outlet_id: selectedOutlet,
                    pageNumber: 1,
                    limit: limit
                  }
                  await fetchTable(params)
                }
                setDeleteConfirmationVisibility(false)
                toastMessage('Table deleted successfully', 'success')
              }
            })
          } else if (deleteOperation == 'servicefloor') {
            let values = _.cloneDeep(selectedServiceFloorData)
            values.id = values._id
            delete values._id
            delete values.business_id
            values.delete_status = true
            delete values.key
            updateServiceFloor(values, async (success, error, message) => {
              if (error) {
                setDeleteConfirmationVisibility(true)
                toastMessage('Service floor deletion failed', 'error')
              } else {
                setDeleteConfirmationVisibility(false)
                toastMessage('Service floor deleted successfully', 'success')
                if (fetchServiceFloorData.length - 1 >= 1) {
                  let params = {
                    outlet_id: selectedOutlet,
                    pageNumber: page1,
                    limit: limit1
                  }
                  await fetchServiceFloor(params)
                } else {
                  setPage1(1)
                  let params = {
                    outlet_id: selectedOutlet,
                    pageNumber: 1,
                    limit: limit1
                  }
                  await fetchServiceFloor(params)
                }
              }
            })
          }
        }}
      />
      <div>
        <Snackbar
          open={snackbar}
          autoHideDuration={SnackBarHideDuration}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={handleSnackbarClose}
          TransitionComponent={SnackBarTransition}
        >
          <Alert onClose={handleSnackbarClose} severity={severity}>
            {PopUpMessage}
          </Alert>
        </Snackbar>
      </div>
    </>
  )
}

export default Tables
